import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, UserCircle2, LogOut, LayoutDashboard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import NotificationBell from "@/components/NotificationBell";
import { Button } from "@/components/ui/button";

const Logo = () => (
  <Link to="/" data-testid="header-logo" className="flex items-center shrink-0">
    <img src="/isbul-logo.png" alt="isbul.org" className="h-14 sm:h-16 w-auto object-contain" />
  </Link>
);

export default function Header() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const navLinks = [
    { label: "İş İlanları", to: "/ilanlar" },
    { label: "Şirketler", to: "/sirketler" },
    { label: "AI İş Eşleştirme", to: "/ai-eslestirme" },
  ];

  const dashLink = user?.role === "admin" ? "/adc" : user?.role === "employer" ? "/isveren" : "/panel";

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 h-16 sm:h-20 flex items-center justify-between gap-4">
        <div className="flex items-center gap-8">
          <Logo />
          <nav className="hidden lg:flex items-center gap-7">
            {navLinks.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`nav-${l.to.replace("/", "")}`} className="text-[15px] font-medium text-[#1f222d] hover:text-blue-600 transition-colors">
                {l.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-2 sm:gap-3">
          {user && user.role !== "admin" && <NotificationBell />}
          {user ? (
            <div className="hidden sm:flex items-center gap-2">
              {user.role === "employer" && (
                <Button data-testid="post-job-btn" onClick={() => navigate("/isveren?tab=new")} className="bg-blue-600 hover:bg-blue-700 text-white rounded-full">
                  İlan Yayınla
                </Button>
              )}
              <Link to={dashLink} data-testid="header-dashboard" className="inline-flex items-center gap-2 px-3 py-2 rounded-full border border-slate-200 hover:border-blue-400 text-sm font-medium text-[#1f222d] transition-colors">
                <LayoutDashboard size={16} /> Panelim
              </Link>
              <button data-testid="header-logout" onClick={() => { logout(); navigate("/"); }} className="w-10 h-10 rounded-full hover:bg-slate-100 flex items-center justify-center">
                <LogOut size={18} className="text-[#1f222d]" />
              </button>
            </div>
          ) : (
            <div className="hidden sm:flex items-center gap-2">
              <Link to="/giris" data-testid="header-login" className="px-4 py-2 text-sm font-medium text-[#1f222d] hover:text-blue-600 transition-colors">
                Giriş Yap
              </Link>
              <Button data-testid="header-register" onClick={() => navigate("/kayit")} className="bg-blue-600 hover:bg-blue-700 text-white rounded-full">
                Kaydol
              </Button>
            </div>
          )}
          <button data-testid="mobile-menu-btn" onClick={() => setOpen((o) => !o)} className="lg:hidden w-10 h-10 rounded-full hover:bg-slate-100 flex items-center justify-center">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white px-4 py-4 space-y-2">
          {navLinks.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block py-2 text-[#1f222d] font-medium">
              {l.label}
            </Link>
          ))}
          <div className="pt-3 border-t border-slate-100 flex flex-col gap-2">
            {user ? (
              <>
                <Link to={dashLink} onClick={() => setOpen(false)} className="flex items-center gap-2 py-2 text-[#1f222d] font-medium"><UserCircle2 size={18} /> Panelim</Link>
                <button onClick={() => { logout(); setOpen(false); navigate("/"); }} className="flex items-center gap-2 py-2 text-left text-red-600 font-medium"><LogOut size={18} /> Çıkış Yap</button>
              </>
            ) : (
              <>
                <Link to="/giris" onClick={() => setOpen(false)} className="py-2 text-[#1f222d] font-medium">Giriş Yap</Link>
                <Link to="/kayit" onClick={() => setOpen(false)} className="py-2 text-blue-600 font-semibold">Kaydol</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
